import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import logo from '../logo.png';
import firebase from '../firebase';
const auth = firebase.auth();

export default function AdminHeaderNav (props) {
  const { user } = props;
  const onClickLogOut = async () => {
    if(!window.confirm('ログアウトしますか？')) return;
    await auth.signOut();
    window.location.reload();
  };

  return (
    <header className="header-nav">
      <Navbar color="dark" dark className="justify-content-between">
        <Link to="/admin" className="d-flex align-items-center">
          <img src={logo} style={{ height: 24 }} />
          <span className="ml-2 text-white">Admin</span>
        </Link>
        <Nav navbar>
          {
            user != null && (
              <UncontrolledDropdown tag="div">
                <DropdownToggle nav caret>
                  {user.displayName}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem tag={Link} to="/mypage/profile">
                    プロフィール
                  </DropdownItem>
                  <DropdownItem onClick={onClickLogOut}>
                    ログアウト
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )
          }
        </Nav>
      </Navbar>
    </header>
  );
};
